import { render, staticRenderFns } from "./createCatalog.vue?vue&type=template&id=3527f80a&scoped=true"
import script from "./createCatalog.vue?vue&type=script&lang=js"
export * from "./createCatalog.vue?vue&type=script&lang=js"
import style0 from "./createCatalog.vue?vue&type=style&index=0&id=3527f80a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3527f80a",
  null
  
)

export default component.exports